'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

require('./ViewMoreList.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewMoreList = function (_React$PureComponent) {
  (0, _inherits3.default)(ViewMoreList, _React$PureComponent);

  function ViewMoreList(props) {
    (0, _classCallCheck3.default)(this, ViewMoreList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ViewMoreList.__proto__ || (0, _getPrototypeOf2.default)(ViewMoreList)).call(this, props));

    _this.onClickViewMore = _this.onClickViewMore.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ViewMoreList, [{
    key: 'onClickViewMore',
    value: function onClickViewMore() {
      this.props.onViewMore(this.props.length);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          children = _props.children,
          total = _props.total,
          length = _props.length,
          _props$moreButtonText = _props.moreButtonText,
          moreButtonText = _props$moreButtonText === undefined ? 'components.viewMoreList.viewMore' : _props$moreButtonText;

      var footer = void 0;

      if (loading) {
        footer = React.createElement(_Spinner2.default, { size: length > 0 ? 30 : 60 });
      } else {
        footer = React.createElement(
          'a',
          { className: 'view-more-list__view-more-link uppercase', onClick: this.onClickViewMore },
          React.createElement(
            'span',
            null,
            moreButtonText
          ),
          React.createElement('span', { className: 'view-more-list__view-more-icon icon-caret-down' })
        );
      }

      return React.createElement(
        'div',
        { className: 'view-more-list' },
        React.createElement(
          'div',
          null,
          children
        ),
        !loading && (total || 0) <= length ? null : React.createElement(
          'div',
          { className: (0, _classnames2.default)({
              'view-more-list--initial-loading__footer': length === 0,
              'view-more-list__footer': length > 0
            }) },
          footer
        )
      );
    }
  }]);
  return ViewMoreList;
}(React.PureComponent);

exports.default = ViewMoreList;